import { useMutation } from '@tanstack/react-query'
import { postNamedCommand } from '../../../../../../service'

export const useArchiveInfographicBlockMutation = () => {
  return useMutation({
    mutationFn: async ({ infographicBlockId }) => {
      const { data } = await postNamedCommand('reports', 'archive-infographic-block', { infographicBlockId })
      return data
    }
  })
}
